import { DatabaseRecord, DatabaseType } from '../../offline-first';
import * as moment_ from 'moment';

export interface PlanUser {
  uuid: string;
  email: string;
  firstName: string;
  lastName: string;
}

export interface PlanGroup {
  uuid: string;
  name: string;
}

export class PlanMetadata extends DatabaseRecord {
  static recordName = 'PlanMetadata';
  static objectStoreName = 'plans';
  static fields = [
    'version',
    'userUUID',
    'id',
    'name',
    'notes',
    'numWeeks',
    'startDate',
    'isDownloaded',
    'sharedWithUsers',
    'publishedToGroups',
    'createdByUser',
  ];

  static databaseType = DatabaseType.Document;

  version: number;
  userUUID: string;
  id: string;
  name: string;
  numWeeks: number;
  startDate: moment_.Moment;
  isDownloaded: boolean;
  sharedWithUsers: PlanUser[];
  publishedToGroups: PlanGroup[];
  createdByUser: PlanUser;
  notes?: string;
}
